import {
  RowDataReducerActionPayload,
  RowDataReducerState,
} from "../../../types";

export const updateRowDataReducerState = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  return {
    ...state,
    ...(payload.schema && { schema: payload.schema }),
    ...(payload.rowData && { rowData: payload.rowData }),
    ...(payload.rowDataErrors && { rowDataErrors: payload.rowDataErrors }),
    ...(payload.rowDataList && { rowDataList: payload.rowDataList }),
    ...(payload.columnDefs && { columnDefs: payload.columnDefs }),
    ...(payload.fileRowDataList && {
      fileRowDataList: payload.fileRowDataList,
    }),
    ...(payload.fileRowDataErrorsList && {
      fileRowDataErrorsList: payload.fileRowDataErrorsList,
    }),
    ...(payload.deletedObjectsList && {
      deletedObjectsList: payload.deletedObjectsList,
    }),
    ...(payload.isReadOnly !== undefined && { isReadOnly: payload.isReadOnly }),
    ...(payload.dialogRowData && { dialogRowData: payload.dialogRowData }),
    ...(payload.dialogRowDataErrors && {
      dialogRowDataErrors: payload.dialogRowDataErrors,
    }),
    ...(payload.resetState && {
      resetState: {
        ...state.resetState,
        ...payload.resetState,
      },
    }),
  };
};
